(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('[data-tfbhd-burger]').forEach(function(burger){
      if(burger.dataset.tfbhdBound) return; burger.dataset.tfbhdBound='1';
      var root = burger.closest('.tfbhd'); if(!root) return;
      var panel = root.querySelector('[data-tfbhd-panel]'); if(!panel) return;
      burger.addEventListener('click', function(){
        var open = panel.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('keydown', function(ev){
        if(ev.key==='Escape' && panel.classList.contains('is-open')){
          panel.classList.remove('is-open'); burger.setAttribute('aria-expanded','false');
        }
      });
    });
  }
  /* De aankondigingsbalk mag wegscrollen, de groene menubalk blijft plakken.
     Sinds de balk drie regels tekst heeft, is de hele header 126px hoog op een
     telefoon van 812px. Blijft dat allemaal staan, dan is 15% van het scherm
     permanent weg. Door de sectie een negatieve top te geven ter hoogte van de
     balk schuift alleen de balk eruit en pint de menubalk op 0.
     Faalrichting: lukt dit niet, dan blijft top 0 en staat alles vast, precies
     zoals het hiervoor deed. Niemand ziet dan een kapotte pagina. */
  function stickyOffset(){
    document.querySelectorAll('.tfbhd').forEach(function(root){
      var sec = root.parentNode;
      while (sec && !(sec.id && sec.id.indexOf('shopify-section') === 0)) sec = sec.parentNode;
      if (!sec) return;
      if (getComputedStyle(sec).position !== 'sticky') return;
      var annc = root.querySelector('.tfbhd__annc');
      sec.style.top = annc ? (-annc.offsetHeight) + 'px' : '0px';
    });
  }
  function refreshCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-tfbhd-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
    }).catch(function(){});
  }
  if(!window.__tfbhdCartPatched){
    window.__tfbhdCartPatched = true;
    var origFetch = window.fetch;
    window.fetch = function(){
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if(typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){
        p.then(function(){ setTimeout(refreshCartCount, 150); });
      }
      return p;
    };
    document.addEventListener('cart:updated', refreshCartCount);
  }
  if(document.readyState!=='loading'){init();stickyOffset();}else{document.addEventListener('DOMContentLoaded',function(){init();stickyOffset();});}
  window.addEventListener('load', stickyOffset);
  window.addEventListener('resize', stickyOffset);
  document.addEventListener('shopify:section:load', function(){ init(); stickyOffset(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-about"] && !Shopify.designMode) return;
  try {
    
(function(){
  function start(){
    var els=document.querySelectorAll('.tfbov-rv:not(.in)');
    if(!('IntersectionObserver' in window)){Array.prototype.forEach.call(els,function(el){el.classList.add('in')});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
    els.forEach(function(el){io.observe(el)});
  }
  if(document.readyState!=='loading'){start();}else{document.addEventListener('DOMContentLoaded',start);}
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-bbq-bereiden"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(root.dataset.tfbbrInit) return; root.dataset.tfbbrInit='1';
    var rvs = root.querySelectorAll('.x-rv');
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
      }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
      rvs.forEach(function(el){ io.observe(el); });
    } else { rvs.forEach(function(el){ el.classList.add('in'); }); }
  }
  function initAll(){ document.querySelectorAll('.tfbbr').forEach(initRoot); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbbr')) initAll(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-bbq-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(root.dataset.tfbbqInit) return; root.dataset.tfbbqInit='1';

    // GALLERY
    var slides = root.querySelectorAll('.tfbbq-slide');
    root.querySelectorAll('.tfbbq-thumb').forEach(function(t){
      t.addEventListener('click', function(){
        var idx = t.getAttribute('data-idx');
        root.querySelectorAll('.tfbbq-thumb').forEach(function(x){x.classList.remove('is-active')});
        t.classList.add('is-active');
        slides.forEach(function(sl){
          var on = sl.getAttribute('data-idx') === idx;
          sl.classList.toggle('is-active', on);
          if(!on){
            var v = sl.querySelector('video'); if(v){ try{v.pause();}catch(e){} }
            var f = sl.querySelector('iframe'); if(f && f.src){ var keep=f.src; f.src=keep; }
          }
        });
      });
    });

    // STAFFELKIEZER, variant-radio's zijn de echte form-input (werkt ook zonder JS)
    var priceNow = root.querySelector('#tfbbq-price-now');
    var mirrors = root.querySelectorAll('[data-tfbbq-price-mirror]');
    function setStaffel(radio){
      root.querySelectorAll('.tfbbq-staffel').forEach(function(o){ o.classList.remove('is-active'); });
      var lab = radio.closest('.tfbbq-staffel'); if(lab) lab.classList.add('is-active');
      var price = radio.getAttribute('data-price') || '';
      if(priceNow) priceNow.textContent = price;
      mirrors.forEach(function(m){ m.textContent = price; });
    }
    root.querySelectorAll('[data-tfbbq-variant]').forEach(function(r){
      r.addEventListener('change', function(){ if(r.checked) setStaffel(r); });
    });

    // COUNTDOWN
    var cd = root.querySelector('.tfbbq-cd');
    if(cd){
      var cutDay = parseInt(cd.getAttribute('data-cutoff-day')||'3',10);
      var cutHour = parseInt(cd.getAttribute('data-cutoff-hour')||'23',10);
      function nextCutoff(){
        var n=new Date(), d=new Date(n);
        var add=(cutDay-n.getDay()+7)%7;
        d.setDate(n.getDate()+add); d.setHours(cutHour,0,0,0);
        if(d<=n) d.setDate(d.getDate()+7);
        return d;
      }
      var target=nextCutoff();
      function tick(){
        if(!document.body.contains(cd)){ clearInterval(iv); return; }
        var diff=target-new Date();
        if(diff<0){target=nextCutoff();diff=target-new Date();}
        var h=Math.floor(diff/3.6e6), m=Math.floor(diff%3.6e6/6e4), sc=Math.floor(diff%6e4/1e3);
        var dd=Math.floor(h/24); h=h%24;
        cd.textContent=(dd>0?dd+'d ':'')+h+'u '+m+'m '+sc+'s';
      }
      tick(); var iv=setInterval(tick,1000);
    }

    // STICKY BAR
    var sticky = root.querySelector('.tfbbq-sticky');
    var buy = root.querySelector('#tfbbq-buy');
    if(sticky && buy){
      window.addEventListener('scroll', function(){
        if(!document.body.contains(sticky)) return;
        sticky.classList.toggle('is-show', buy.getBoundingClientRect().bottom < 60);
      }, {passive:true});
    }

    // SCROLL REVEAL
    var rvs = root.querySelectorAll('.x-rv');
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
      }, {threshold:.12, rootMargin:'0px 0px -8% 0px'});
      rvs.forEach(function(el){ io.observe(el); });
    } else { rvs.forEach(function(el){ el.classList.add('in'); }); }
  }

  function initAll(){ document.querySelectorAll('.tfbbq').forEach(initRoot); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbbq')) initAll(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rm = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var lite = window.matchMedia('(max-width:820px)').matches || window.matchMedia('(pointer:coarse)').matches;

  function init(){
    var h1=document.querySelector('[data-tfbx-split]');
    if(h1 && !h1.dataset.splitDone){
      h1.dataset.splitDone='1';
      var frag=[];
      Array.prototype.forEach.call(h1.childNodes, function(n){
        if(n.nodeType===3){
          n.textContent.split(/(\s+)/).forEach(function(t){
            if(!t) return;
            if(!t.trim()){ frag.push(document.createTextNode(t)); return; }
            var last=frag[frag.length-1];
            if(/^[^\w]+$/.test(t) && last && last.nodeType===1 && last.getAttribute('data-w')==='1'){ last.appendChild(document.createTextNode(t)); return; }
            var s=document.createElement('span');s.className='tfbx-w';s.setAttribute('data-w','1');s.textContent=t;frag.push(s);
          });
        } else if(n.nodeType===1){ n.classList.add('tfbx-w'); frag.push(n); } else { frag.push(n); }
      });
      h1.innerHTML=''; frag.forEach(function(f){h1.appendChild(f);});
      h1.querySelectorAll('.tfbx-w').forEach(function(w,i){w.style.transitionDelay=(0.15+i*0.08)+'s';});
      requestAnimationFrame(function(){h1.classList.add('is-go');});
    }

    var els=document.querySelectorAll('.tfbx-rv:not(.in)');
    if(!('IntersectionObserver' in window)){ Array.prototype.forEach.call(els,function(el){el.classList.add('in');}); }
    else{
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.15});
      Array.prototype.forEach.call(els,function(el){io.observe(el);});
    }
    if('IntersectionObserver' in window){
      var cio=new IntersectionObserver(function(es){es.forEach(function(e){
        if(!e.isIntersecting) return; var el=e.target; cio.unobserve(el);
        var end=parseFloat(String(el.getAttribute('data-tfbx-count')).replace(',','.')), suf=el.getAttribute('data-suffix')||'', t0=null, dur=1400;
        if(isNaN(end)) return;
        function tick(t){if(!t0)t0=t;var p=Math.min((t-t0)/dur,1);el.textContent=Math.round(p*end)+suf;if(p<1)requestAnimationFrame(tick);}
        requestAnimationFrame(tick);
      });},{threshold:.5});
      document.querySelectorAll('[data-tfbx-count]:not([data-counted])').forEach(function(el){el.setAttribute('data-counted','1');cio.observe(el);});
    }

    if(rm) return;

    document.querySelectorAll('.tfbx-tilt:not([data-tilt-bound])').forEach(function(c){
      c.setAttribute('data-tilt-bound','1');
      c.addEventListener('mousemove', function(e){var r=c.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;c.style.transform='rotateY('+(px*9)+'deg) rotateX('+(-py*9)+'deg) translateY(-8px)';});
      c.addEventListener('mouseleave', function(){c.style.transform='';});
    });

    // Magneet-effect op knoppen verwijderd (Kay 14-08): klik moet direct voelen.
  }

  var ticking=false;
  function onScrollFrame(){
    ticking=false;
    var h=document.documentElement, sc=h.scrollHeight>h.clientHeight ? h.scrollTop/(h.scrollHeight-h.clientHeight) : 0;
    var prog=document.querySelector('[data-tfbx-progress]');
    if(prog) prog.style.width=(sc*100)+'%';
    var nav=document.querySelector('[data-tfbx-nav]');
    if(nav) nav.classList.toggle('is-solid', window.scrollY>40);
    if(rm || lite) return;
    document.querySelectorAll('[data-tfbx-pllx]').forEach(function(p){var r=p.getBoundingClientRect();var off=(r.top+r.height/2-window.innerHeight/2)*.08;p.style.transform='translateY('+off+'px)';});
  }
  if(!window.__tfbxScrollBound){
    window.__tfbxScrollBound=true;
    window.addEventListener('scroll', function(){ if(!ticking){ ticking=true; requestAnimationFrame(onScrollFrame); } }, {passive:true});
  }

  if(document.readyState!=='loading'){ init(); onScrollFrame(); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(); onScrollFrame(); }); }
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbx-hero')) { init(); onScrollFrame(); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-how"] && !Shopify.designMode) return;
  try {
    
(function(){
  function start(){
    var els = document.querySelectorAll('.tfbhw-rv:not(.in)');
    if(!('IntersectionObserver' in window)){ Array.prototype.forEach.call(els,function(el){el.classList.add('in')}); }
    else{
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
      els.forEach(function(el){io.observe(el)});
    }
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    document.querySelectorAll('[data-tfbhw-bubbles]').forEach(function(cv){
      if(cv.dataset.init) return; cv.dataset.init='1';
      var cx=cv.getContext('2d'),W,H,b=[];
      function rs(){W=cv.width=cv.offsetWidth;H=cv.height=cv.offsetHeight;}
      function mk(){return{x:Math.random()*W,y:H+Math.random()*H,r:1+Math.random()*3.5,s:.3+Math.random()*1,o:.08+Math.random()*.28};}
      function init(){rs();b=[];var n=Math.min(40,Math.floor(W/30));for(var i=0;i<n;i++)b.push(mk());}
      function draw(){cx.clearRect(0,0,W,H);b.forEach(function(p){p.y-=p.s;p.x+=Math.sin(p.y*.02)*.3;if(p.y<-10){p.x=Math.random()*W;p.y=H+10;}cx.beginPath();cx.arc(p.x,p.y,p.r,0,7);cx.fillStyle='rgba(201,172,118,'+p.o+')';cx.fill();});requestAnimationFrame(draw);}
      init();draw();window.addEventListener('resize',rs);
    });
  }
  if(document.readyState!=='loading'){ start(); } else { document.addEventListener('DOMContentLoaded', start); }
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-product-box"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(root.dataset.tfbppInit) return; root.dataset.tfbppInit='1';

    // GALLERY
    var slides = root.querySelectorAll('.tfbpp-slide');
    root.querySelectorAll('.tfbpp-thumb').forEach(function(t){
      t.addEventListener('click', function(){
        var idx = t.getAttribute('data-idx');
        root.querySelectorAll('.tfbpp-thumb').forEach(function(x){x.classList.remove('is-active')});
        t.classList.add('is-active');
        slides.forEach(function(sl){
          var on = sl.getAttribute('data-idx') === idx;
          sl.classList.toggle('is-active', on);
          if(!on){
            var v = sl.querySelector('video'); if(v){ try{v.pause();}catch(e){} }
            var f = sl.querySelector('iframe'); if(f && f.src){ var keep=f.src; f.src=keep; }
          }
        });
      });
    });

    // PLAN TOGGLE — selling_plan-radio's zijn de echte input (werkt ook zonder JS)
    var subRadio = root.querySelector('[data-tfbpp-subradio]');
    var freq = root.querySelector('#tfbpp-freq');
    var priceNow = root.querySelector('#tfbpp-price-now');
    var priceWas = root.querySelector('#tfbpp-price-was');
    var savePill = root.querySelector('#tfbpp-savepill');
    var stickyWas = root.querySelector('#tfbpp-sticky-was');
    var mirrors = root.querySelectorAll('[data-tfbpp-price-mirror], #tfbpp-sticky-price');
    var onePrice = priceWas ? priceWas.textContent : (priceNow ? priceNow.textContent : '');
    var subPrice = priceNow ? priceNow.textContent : '';

    function setPlan(isSub){
      root.querySelectorAll('.tfbpp-planopt').forEach(function(o){ o.classList.toggle('is-active', (o.getAttribute('data-plan')==='sub')===isSub); });
      var price = subPrice;
      if(priceNow) priceNow.textContent = price;
      mirrors.forEach(function(m){ m.textContent = price; });
      if(priceWas) priceWas.style.display = '';
      if(savePill) savePill.style.display = isSub ? '' : 'none';
      if(stickyWas) stickyWas.style.display = isSub ? '' : 'none';
      if(freq){ freq.style.opacity = isSub ? '1' : '.4'; freq.style.pointerEvents = isSub ? '' : 'none';
        freq.querySelectorAll('input').forEach(function(i){ i.disabled = !isSub; }); }
    }
    setPlan(false); root.querySelectorAll('input[name="selling_plan"]').forEach(function(r){
      r.addEventListener('change', function(){ setPlan(r.getAttribute('data-tfbpp-plan')==='sub'); });
    });
    root.querySelectorAll('input[name="tfbpp_freq"]').forEach(function(r){
      r.addEventListener('change', function(){
        root.querySelectorAll('.tfbpp-pill').forEach(function(pl){pl.classList.remove('is-active')});
        r.closest('.tfbpp-pill').classList.add('is-active');
        if(subRadio){ subRadio.value = r.value; subRadio.checked = true; setPlan(true); }
      });
    });

    // COUNTDOWN
    var cd = root.querySelector('.tfbpp-cd');
    if(cd){
      var cutDay = parseInt(cd.getAttribute('data-cutoff-day')||'1',10);
      var cutHour = parseInt(cd.getAttribute('data-cutoff-hour')||'23',10);
      function nextCutoff(){
        var n=new Date(), d=new Date(n);
        var add=(cutDay-n.getDay()+7)%7;
        d.setDate(n.getDate()+add); d.setHours(cutHour,0,0,0);
        if(d<=n) d.setDate(d.getDate()+7);
        return d;
      }
      var target=nextCutoff();
      function tick(){
        if(!document.body.contains(cd)){ clearInterval(iv); return; }
        var diff=target-new Date();
        if(diff<0){target=nextCutoff();diff=target-new Date();}
        var h=Math.floor(diff/3.6e6), m=Math.floor(diff%3.6e6/6e4), sc=Math.floor(diff%6e4/1e3);
        var dd=Math.floor(h/24); h=h%24;
        cd.textContent=(dd>0?dd+'d ':'')+h+'u '+m+'m '+sc+'s';
      }
      tick(); var iv=setInterval(tick,1000);
    }

    // STICKY BAR
    var sticky = root.querySelector('.tfbpp-sticky');
    var buy = root.querySelector('#tfbpp-buy');
    if(sticky && buy){
      window.addEventListener('scroll', function(){
        if(!document.body.contains(sticky)) return;
        sticky.classList.toggle('is-show', buy.getBoundingClientRect().bottom < 60);
      }, {passive:true});
    }
  }

  function initAll(){ document.querySelectorAll('.tfbpp').forEach(initRoot); }
  if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbpp')) initAll(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-product-clean"] && !Shopify.designMode) return;
  try {
    
/* Alleen galerij en plakbalk. De koop- en betaallogica staat in
   snippets/tfb-abo-routing.liquid. Zet die hier nooit terug: dan draaien er twee
   scripts op hetzelfde formulier en dat is precies hoe de dubbele korting ontstond. */
(function(){
  function initRoot(root){
    if(root.dataset.tfbpcInit) return;
    root.dataset.tfbpcInit = '1';

    var stage = root.querySelector('.tfbpc-stage');
    var dots = root.querySelectorAll('.tfbpc-dot');
    if(stage && dots.length){
      dots.forEach(function(d){
        d.addEventListener('click', function(){
          var i = parseInt(d.getAttribute('data-idx'), 10) || 0;
          stage.scrollTo({left: i * stage.clientWidth, behavior: 'smooth'});
        });
      });
      stage.addEventListener('scroll', function(){
        var i = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
        dots.forEach(function(d, n){ d.classList.toggle('is-active', n === i); });
      }, {passive:true});
    }

    var sticky = root.querySelector('.tfbpp-sticky');
    var buy = root.querySelector('#tfbpp-buy');
    if(sticky && buy){
      window.addEventListener('scroll', function(){
        if(!document.body.contains(sticky)) return;
        sticky.classList.toggle('is-show', buy.getBoundingClientRect().bottom < 60);
      }, {passive:true});
    }
  }
  function initAll(){ document.querySelectorAll('.tfbpc').forEach(initRoot); }
  if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbpc')) initAll(); });
})();
// 27-08 (Titi), akkoord Kay: kwam de bezoeker binnen via /discount/AANBOORD, dan staat de cookie discount_code=AANBOORD en betaalt hij 28 euro minder. Toon dan meteen die prijs met de volle prijs doorgestreept, anders zag hij hier 67,95 terwijl de advertentie 39,95 beloofde. Geen cookie is geen korting, dan blijft de volle prijs staan.
(function(){function nrm(t){return String(t).replace(/\s+/g,' ').trim();}function go(){try{if(document.cookie.indexOf('discount_code=AANBOORD')<0)return;var b=document.querySelector('.tfbpc-pricebar[data-tfb-actie]');if(!b||b.getAttribute('data-tfb-actie')!=='1')return;var k=nrm(b.getAttribute('data-tfb-aanboord')),v=nrm(b.getAttribute('data-tfb-vol'));if(!k||!v||k===v)return;var n=b.querySelector('#tfbpp-price-now');if(!n||nrm(n.textContent)!==v)return;n.textContent=k;var w=document.createElement('span');w.className='tfbpc-was';w.textContent=v;n.insertAdjacentElement('afterend',w);document.querySelectorAll('.tfbpc-bar .l2').forEach(function(el){if(nrm(el.textContent)===v){el.textContent=k;}});}catch(e){}}if(document.readyState!=='loading'){go();}else{document.addEventListener('DOMContentLoaded',go);}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.querySelector('.tfbq'); if(!root) return;
    var cfg=root.querySelector('[data-tfbq-boxes]'); if(!cfg) return;
    var BOXES; try{BOXES=JSON.parse(cfg.textContent);}catch(e){return;}
    var QUESTIONS=[
      {q:"Voor hoeveel mensen kook je meestal?",o:[
        {t:"Vooral voor mezelf",s:{sig:1,pro:2}},
        {t:"Met z'n tweeën",s:{sig:3}},
        {t:"Een gezin met kinderen",s:{fam:3}}
      ]},
      {q:"Wat spreekt je het meest aan?",o:[
        {t:"Gemak en altijd goede kwaliteit",s:{sig:3}},
        {t:"Gezond en simpel voor het hele gezin",s:{fam:3}},
        {t:"Veel vis: drie volle porties, geen bijportie",s:{pro:3}},
        {t:"Verrassend, altijd iets bijzonders erbij",s:{sig:3}}
      ]},
      {q:"Hou je van bijzondere of rauwe vis (sashimi, oesters, schaaldieren)?",o:[
        {t:"Ja, verras me maar",s:{sig:2,pro:1}},
        {t:"Af en toe wel leuk",s:{sig:2}},
        {t:"Liever vertrouwde vis",s:{fam:2,sig:1}}
      ]},
      {q:"Hoe vaak wil je vis eten per week?",o:[
        {t:"Twee mooie maaltijden",s:{sig:2,fam:1}},
        {t:"Drie keer of meer, ik kook vooruit",s:{pro:3}},
        {t:"Wisselend, vooral genieten",s:{sig:3}}
      ]}
    ];
    var q=function(sel){return root.querySelector(sel);};
    var idx=0, answers=[];
    var step=q('[data-tfbq-step]'),title=q('[data-tfbq-title]'),opts=q('[data-tfbq-opts]'),
        pfill=q('[data-tfbq-pfill]'),back=q('[data-tfbq-back]'),qarea=q('[data-tfbq-qarea]'),
        calc=q('[data-tfbq-calc]'),result=q('[data-tfbq-result]');

    function render(){
      var Q=QUESTIONS[idx];
      step.textContent='Vraag '+(idx+1)+' van '+QUESTIONS.length;
      title.textContent=Q.q;
      pfill.style.width=(idx/QUESTIONS.length*100)+'%';
      opts.innerHTML='';
      Q.o.forEach(function(o,i){
        var b=document.createElement('button');b.type='button';b.className='tfbq-opt';
        b.innerHTML='<span class="dot"></span> '+o.t;
        b.addEventListener('click',function(){choose(i);});
        opts.appendChild(b);
      });
      back.style.display=idx>0?'inline-block':'none';
      qarea.classList.remove('anim');void qarea.offsetWidth;qarea.classList.add('anim');
    }
    function choose(i){answers[idx]=QUESTIONS[idx].o[i].s;if(idx<QUESTIONS.length-1){idx++;render();}else{showCalc();}}
    back.addEventListener('click',function(){if(idx>0){idx--;render();}});

    function showCalc(){
      pfill.style.width='100%';qarea.style.display='none';calc.classList.add('show');
      var msgs=["Jouw smaak analyseren…","De dagvangst raadplegen…","Porties afstemmen…","Jouw perfecte box kiezen…"];
      var m=q('[data-tfbq-msg]'),mi=0;m.textContent=msgs[0];
      var iv=setInterval(function(){mi=(mi+1)%msgs.length;m.style.opacity=0;setTimeout(function(){m.textContent=msgs[mi];m.style.opacity=1;},250);},720);
      setTimeout(function(){clearInterval(iv);calc.classList.remove('show');showResult();},2900);
    }
    function showResult(){
      var tot={sig:0,fam:0,pro:0};
      answers.forEach(function(sc){for(var k in sc){tot[k]=(tot[k]||0)+sc[k];}});
      var best='sig',bestv=-1;
      ['sig','fam','pro'].forEach(function(k){if(tot[k]>bestv){bestv=tot[k];best=k;}});
      var B=BOXES[best]||{};
      var nm=B.name||'Signature';
      q('[data-tfbq-match]').textContent='De '+nm+' Box';
      var im=q('[data-tfbq-img]'); if(B.img){im.src=B.img;im.alt='De '+nm+' Box';} 
      var bd=q('[data-tfbq-badge]'); bd.textContent=B.badge||''; bd.style.display=B.badge?'':'none';
      q('[data-tfbq-name]').textContent=nm;
      q('[data-tfbq-price]').textContent=B.price||'';
      q('[data-tfbq-desc]').textContent=B.desc||'';
      var cta=q('[data-tfbq-cta]');cta.href=B.url||'/pages/onze-visboxen';cta.textContent='Bekijk de '+nm;
      result.classList.add('show');
      var pct=Math.min(99,84+bestv*2),el=q('[data-tfbq-pct]'),cur=0;
      var ci=setInterval(function(){cur+=3;if(cur>=pct){cur=pct;clearInterval(ci);}el.textContent=cur;},28);
    }
    q('[data-tfbq-restart]').addEventListener('click',function(){
      idx=0;answers=[];result.classList.remove('show');calc.classList.remove('show');qarea.style.display='';render();
    });
    render();
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  document.addEventListener('shopify:section:load', function(e){ if(e.target && e.target.querySelector && e.target.querySelector('.tfbq')) init(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-visboxen-kaarten"] && !Shopify.designMode) return;
  try {
    
/* 1:1 uit sections/tfb-homepage.liquid: reveal-observer + kaart-tilt. */
(function(){
  function init(){
    var els = document.querySelectorAll('.tfbxk .tfbx-rv:not(.in)');
    if(!('IntersectionObserver' in window)){ Array.prototype.forEach.call(els,function(el){el.classList.add('in');}); }
    else{
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.15});
      Array.prototype.forEach.call(els,function(el){io.observe(el);});
    }
    document.querySelectorAll('.tfbxk .tfbx-tilt:not([data-tilt-bound])').forEach(function(c){
      c.setAttribute('data-tilt-bound','1');
      c.addEventListener('mousemove', function(e){var r=c.getBoundingClientRect();var px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;c.style.transform='rotateY('+(px*9)+'deg) rotateX('+(-py*9)+'deg) translateY(-8px)';});
      c.addEventListener('mouseleave', function(){c.style.transform='';});
    });
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-visboxen-upfront"] && !Shopify.designMode) return;
  try {
    
/* Pointer-tilt: het boxbeeld kantelt mee met de cursor (3D-gevoel), de schaduw
   beweegt de andere kant op. Alleen transform en box-shadow, dus nul layout-shift.
   Op touch (geen hover) gebeurt er niets: daar staat het beeld gewoon stil. */
(function(){
  if(!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  function init(){
    document.querySelectorAll('[data-tfbu-tilt]').forEach(function(card){
      if(card.dataset.tfbuBound) return; card.dataset.tfbuBound='1';
      var img = card.querySelector('.tfbu__media img'); if(!img) return;
      card.addEventListener('mousemove', function(ev){
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;   /* -0.5 .. 0.5 */
        var py = (ev.clientY - r.top) / r.height - 0.5;
        var ry = px * 16;   /* max 8 graden */
        var rx = py * -10;  /* max 5 graden */
        img.style.transform = 'perspective(900px) rotateY(' + ry.toFixed(2) + 'deg) rotateX(' + rx.toFixed(2) + 'deg) scale(1.05)';
        img.style.filter = 'drop-shadow(' + (-ry * 1.6).toFixed(1) + 'px ' + (Math.abs(rx) * 1.5 + 16).toFixed(1) + 'px 24px rgba(14,42,34,.26))';
      });
      card.addEventListener('mouseleave', function(){
        img.style.transform = '';
        img.style.filter = '';
      });
    });
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfb-vorige-week"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('.tfbvw[data-tfbvw-relocate]').forEach(function(el){
      var slot = document.getElementById('tfbvw-slot');
      var card = document.querySelector('.tfbpp-portions');
      if(!slot){
        if(card){
          slot = document.createElement('div');
          slot.id = 'tfbvw-slot';
          slot.style.order = '21';
          slot.style.width = '100%';
          slot.style.flexBasis = '100%';
          card.parentNode.insertBefore(slot, card.nextSibling);
        }
      }
      if(slot && el.parentNode !== slot){
        slot.appendChild(el);
        el.classList.add('tfbvw--embedded');
        if(card){ card.style.display = 'none'; }
      }
    });
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
